'use strict';

var ChartDashboardPerformanceLegendDirective = function ChartDashboardPerformanceLegendDirective() {
  return {
    restrict: 'E',
    template: require('../templates/chart-dashboard-performance-legend.html'),
    controller: 'ChartDashboardPerformanceLegendController',
    scope: {
      cogChannel: '@',
      resetChartHandler: '=',
      cogOptionsSelected: '=',
      screenState: '=',
      metricLabels: '='
    },
    link: function link($scope) {
      $scope.$on('search-criteria:searchChangeEvent', $scope.setDefaultState);
      $scope.$on('cog:market-performance-chart', $scope.updateCogOptions);
    }
  };
};
ChartDashboardPerformanceLegendDirective.$inject = [];
module.exports = ChartDashboardPerformanceLegendDirective;